import React from 'react';
import 'yuki-createjs';
import { connect } from 'react-redux';
import { charInc, charClear } from '../../../actions/char';
import Char from '../shared/Char';
import TraceOnBtn from '../shared/TraceOnBtn';
import TraceOffBtn from '../shared/TraceOffBtn';
import GuidelinesOnBtn from '../shared/GuidelinesOnBtn';
import GuidelinesOffBtn from '../shared/GuidelinesOffBtn';
import { setOwnSpacing } from '../../../utils/utils';

export class OwnWatch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            char: undefined,
            charCase: 'lc',
            charClearState: false,
            total: 0,
            array: [],
            isPlaying: false,
            guidelinesShown: true
        };

        createjs.Ticker.on('tick', this.tick, this);
        createjs.Ticker.framerate = 30;
    }
    load() {
        this.props.charInc();

        this.state.loader = new createjs.LoadQueue(true);
        this.state.loader.on('complete', this.create, this);

        this.state.manifest = [{ 
            src: 'images/sections/' + this.state.charCase + '/chars/watch/' + this.state.char + '.json', 
            id: 'own-watch-spritesheet',
            type: 'spritesheet'
        }];

        while (this.state.manifest.length > 0) {
            this.state.loader.loadFile(this.state.manifest.shift());
        }
    }
    create() {
        let _this = this,
            idx = this.state.array.length,
            cvs = document.getElementById('lc-watch-cvs-' + idx);

        this.state.array[idx] = new Object();
        this.state.array[idx].canvas = cvs;
        this.state.array[idx].stage = new createjs.Stage(this.state.array[idx].canvas);
        this.state.array[idx].anim = new createjs.Sprite(this.state.loader.getResult('own-watch-spritesheet'));
        this.state.array[idx].anim.id = idx;
        this.state.array[idx].char = this.state.char;
        this.state.array[idx].spacing = setOwnSpacing(this.state.char, this.state.charCase);

        this.state.array[idx].stage.addChild(this.state.array[idx].anim);
        this.state.array[idx].anim.on('animationend', this.end, this);

        $(window).on('resize.own-watch', function() {
            _this.resize();
        });

        this.resize();
    }
    end(e) {
        e.target.stop();

        if (e.target.id < (this.state.array.length - 1)) {
            this.state.array[e.target.id + 1].anim.gotoAndPlay('active');
        } else {
            for (var i = 0; i < this.state.array.length; i++) {
                this.state.array[i].anim.gotoAndStop('inactive');
            }
            this.state.array[0].anim.gotoAndPlay('active');
        }
    }
    tick() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.array.length; i++) {
                if (this.state.array[i].stage !== undefined) {
                    this.state.array[i].stage.update();
                }
            }
        }
    }
    pos() {
        const holder = $('.holder-inner', '#own-watch'),
            holderBaseW = 598,
            holderBaseH = 104;
        let char = $('.char-holder', '#own-watch'),
            holderW = holder.width(),
            holderH = holder.height(),
            holderPercW = holderW / 100,
            holderPercH = holderH / 100,
            spaceW,
            xPosStart = 15,
            xPos = xPosStart,
            xInc,
            letter,
            spacingX = 5;

        for (let i = 0; i < this.state.array.length; i++) {

            letter = this.state.array[i].char;

            if (xPos !== xPosStart) {
                if (letter === 'j') {
                    //xPos -= holderPercW * (((16*0.8)/holderBaseW) * 100);
                } else if (letter === 'g') {
                    xPos -= holderPercW * (((6*0.8)/holderBaseW) * 100)
                }
            }

            spaceW = ((this.state.array[i].spacing[1] + spacingX)*0.8);
            xInc = holderPercW * ((spaceW/holderBaseW) * 100);

            char.eq(i).css('left', xPos + 'px');

            xPos += xInc;
        }
    }
    resize() {
        const parent = $('.char-holder'),
            curr = $('.lc-watch-cvs');
        let parentW = parent.width(),
            parentH = parent.height(),
            currW = curr.width(),
            currH = curr.height(),
            scale = parentH / 300;

        curr.attr('height', $('#own-watch').height() - $('.holder', '#own-watch').position().top);
        
        for (var i = 0; i < this.state.array.length; i++) {
            this.state.array[i].stage.scaleX = scale;
            this.state.array[i].stage.scaleY = scale;
        }

        this.pos();
    }
    clear() {
        if (this.state.charClearState) {
            this.stop();
            this.setState({ 
                total: 0,
                array: [],
                charClearState: false
            });
            this.props.charClear(false);
        }
    }
    play() {
        this.stop();
        if (this.state.array.length) {
            this.state.array[0].anim.gotoAndPlay('active');
        }
        this.setState({ isPlaying: true });
    }
    stop() {
        if (this.state.array.length) {
            for (var i = 0; i < this.state.total; i++) {
                this.state.array[i].anim.gotoAndStop('active');
            }
        }
        this.setState({ isPlaying: false });
    }
    guidelinesShow() {
        $('.guidelines', '#own-watch').show();
        this.setState({ guidelinesShown: true });
    }
    guidelinesHide() {
        $('.guidelines', '#own-watch').hide();
        this.setState({ guidelinesShown: false });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.char) {
            this.setState({ 
                char: nextProps.char,
                charCase: nextProps.charCase,
                total: this.state.total + 1
            });
        }
        if (nextProps.charClearState) {
            this.setState({ 
                charClearState: nextProps.charClearState
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ((prevState.total !== this.state.total) && (this.state.total !== 0)) {
            this.load();
        }
        if (prevState.charClearState !== this.state.charClearState) {
            this.clear();
        }
    }
    componentWillUnmount() {
        $(window).off('resize.own-watch');
    }
    render() {
        return (
            <div id="own-watch" className="panel">
                <div className="title"></div>
                <div className="panel-arrow-d"></div>
                <div className="guidelines-txt"></div>
                <GuidelinesOffBtn onClick={this.guidelinesHide.bind(this)} selected={!this.state.guidelinesShown} />
                <GuidelinesOnBtn onClick={this.guidelinesShow.bind(this)} selected={this.state.guidelinesShown} />
                <div className="trace-txt"></div>
                <TraceOffBtn onClick={this.stop.bind(this)} selected={!this.state.isPlaying} />
                <TraceOnBtn onClick={this.play.bind(this)} selected={this.state.isPlaying} />
                <div className="holder">
                    <div className="holder-inner">
                        {[...Array(this.state.total)].map((label, index) => {
                            return (
                                <Char key={index} id={index} charType="lc" animType="watch" />
                            );
                        })}
                    </div>
                    <div className="guidelines"></div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        char: state.char.char,
        charCase: state.char.charCase,
        charClearState: state.char.charClearState
    };
}

const mapDispatchToProps = (dispatch) => ({
    charInc: () => dispatch(charInc()),
    charClear: (charClearState) => dispatch(charClear(charClearState))
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnWatch);



// WEBPACK FOOTER //
// ./src/components/sections/own/OwnWatch.js